import { createStore } from "easy-peasy";
import usersModel from "./models/users.model";
import authModel from "./models/auth.model";
import userDetailModel from "./models/userDetail.model";

const store = createStore({
  users: usersModel,
  auth: authModel,
  userDetail: userDetailModel,
});

export default store;
